import React from 'react'

function IconFinances ({fill=''}){
  return (
    <svg width="24" height="24" viewBox="0 0 24 24"  className={fill} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.5 13C19.0899 13 22 12.1046 22 11C22 9.89543 19.0899 9 15.5 9C11.9101 9 9 9.89543 9 11C9 12.1046 11.9101 13 15.5 13Z"  strokeWidth="1.5"/>
        <path d="M22 15.5C22 16.6046 19.0899 17.5 15.5 17.5C11.9101 17.5 9 16.6046 9 15.5"  strokeWidth="1.5"/>
        <path d="M22 11V19.8C22 21.015 19.0899 22 15.5 22C11.9101 22 9 21.015 9 19.8V11"  strokeWidth="1.5"/>
        <path d="M8.5 6C12.0899 6 15 5.10457 15 4C15 2.89543 12.0899 2 8.5 2C4.91015 2 2 2.89543 2 4C2 5.10457 4.91015 6 8.5 6Z"  strokeWidth="1.5"/>
        <path d="M6 11C4.10819 10.7698 2.36991 10.1745 2 9M6 16C4.10819 15.7698 2.36991 15.1745 2 14"  strokeWidth="1.5"/>
        <path d="M6 21C4.10819 20.7698 2.36991 20.1745 2 19V4"  strokeWidth="1.5"/>
        <path d="M15 6V4"  strokeWidth="1.5"/>
        </svg>

  )
}

export default IconFinances
